import React, { useCallback } from 'react';
import useTranslate from '@/hooks/useTranslate';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import CircularProgress from '@mui/material/CircularProgress';
import {
  TranslatePopup,
  TranslateColumn,
} from '@/pages/document/DocumentViewer/DocumentFileView/PageView/PageOcrLayer/OcrWords/TranslatePopup/StyledComponents';

const MAX_MENU_HEIGHT = 300;

const PageTranslatePopup = ({ text }) => {
  const {
    availableTranslationList,
    targetTranslateOption,
    sourceTranslateOption,
    onChangeTargetTranslateOption,
    onChangeSourceTranslateOption,
    targetTranslate,
    isTranslating,
  } = useTranslate(text);

  const getValue = useCallback(
    (value) => availableTranslationList.find((i) => i.value === value) || null,
    [availableTranslationList],
  );

  return (
    <TranslatePopup>
      <Stack direction="row" spacing={1} overflow="hidden">
        <Box flex="1 1 50%" pb={1}>
          <TranslateColumn>
            <Typography variant="body2" color="grey.700">
              {text}
            </Typography>
          </TranslateColumn>
        </Box>
        <Divider orientation="vertical" flexItem />
        <Box flex="1 1 50%" pb={1}>
          <TranslateColumn>
            <Typography variant="body2">{targetTranslate}</Typography>
            {isTranslating && (
              <Box display="flex" justifyContent="center" alignItems="center" height="100%" m="auto">
                <CircularProgress />
              </Box>
            )}
          </TranslateColumn>
        </Box>
      </Stack>
      <Stack direction="row" spacing={1}>
        <Autocomplete
          disableClearable
          fullWidth
          size="small"
          id="sourceTranslateOption"
          options={availableTranslationList}
          onChange={onChangeSourceTranslateOption}
          value={getValue(sourceTranslateOption)}
          renderInput={(params) => <TextField {...params} />}
          slotProps={{ listbox: { style: { maxHeight: MAX_MENU_HEIGHT } } }}
        />
        <Autocomplete
          disableClearable
          fullWidth
          size="small"
          id="targetTranslateOption"
          options={availableTranslationList}
          onChange={onChangeTargetTranslateOption}
          value={getValue(targetTranslateOption)}
          renderInput={(params) => <TextField {...params} />}
          slotProps={{ listbox: { style: { maxHeight: MAX_MENU_HEIGHT } } }}
        />
      </Stack>
    </TranslatePopup>
  );
};

export default PageTranslatePopup;
